<template>
  <label
    :for="labelFor"
    class="relative mb-0 cursor-pointer"
    :class="{ 'cursor-not-allowed text-neutral-400': disabled }"
  >
    <p class="text-sm font-light">{{ $t(label) }} <span
      v-if="required"
      class="text-primary-700"
    >*</span>
    </p>
    <slot :id="labelFor" />
  </label>
</template>

<script lang="ts" setup>
interface Props {
  label: string;
  labelFor?: string;
  required?: boolean;
  disabled?: boolean;
}

defineProps<Props>();
</script>
